import NewResponsiveImage from "@components/CustomTypography/NewResponsiveImage/NewResponsiveImage"
import Separator from "@components/CustomTypography/Separator/Separator"
import ButtonSwitcher from "@components/Switchers/ButtonSwitcher/ButtonSwitcher"
import ButtonContainer from "@components/WebsiteRevamp/ButtonContainer/ButtonContainer"
import Typography, {
	Size,
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {AdvancedSideAssetMainContent} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./ProductCard.module.scss"

type Props = {
	data: AdvancedSideAssetMainContent
	containerClassName?: string
	containterWrapperClassName?: string
	containerTopWrapperClassName?: string
}

const ProductCard = (props: Props) => {
	return (
		<div className={`${styles.container} ${props.containerClassName}`}>
			<div
				className={`${styles.containerWrapper} ${props.containterWrapperClassName}`}
			>
				<div className={styles.contentContainer}>
					<Typography
						content={props.data.upperTitle}
						fontWeight={400}
						size={Size.S}
						as={"h4"}
						variant={Variant.Title}
					/>
					<Separator size={32} />
					{props.data?.inside && (
						<NewResponsiveImage
							{...props.data?.inside}
							containerClassName={styles.logoBox}
							imageClassName={styles.logoImage}
							src={props.data?.inside?.src ?? ""}
							alt={
								props.data.title ?? props.data.inside?.alt ?? ""
							}
						/>
					)}
					<Separator size={32} />
				</div>
				<div className={styles.assetContainer}>
					<div />
				</div>
			</div>

			<div
				className={`${styles.containerWrapper} ${props.containterWrapperClassName}`}
			>
				<div className={styles.contentContainer}>
					<Typography
						content={props.data.title}
						fontWeight={500}
						size={Size.L}
						variant={Variant.Title}
						noPadding
					/>
					<Separator size={32} />
					<Typography
						content={props.data.content}
						variant={Variant.Description}
						noPadding
						stripHtml={false}
					/>
					<Separator size={32} />
					{props.data.buttons?.length != null &&
						props.data.buttons?.length > 0 && (
							<ButtonContainer>
								<ButtonSwitcher buttonsList={props.data} />
							</ButtonContainer>
						)}
				</div>
				<div className={styles.assetContainer}>
					<NewResponsiveImage
						{...props.data?.preview}
						alt={props.data.title ?? props.data.preview?.alt ?? ""}
						src={props.data?.preview?.src ?? ""}
						style={
							{
								// aspectRatio: "16/9",
							}
						}
					/>
				</div>
			</div>
		</div>
	)
}

export default ProductCard
